import PropTypes from 'prop-types';

const MenuIcon = ({ width = '24px', height, stroke = 'currentColor', className }) => {
  const h = height || width;

  return (
    <svg
      width={width}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
};

MenuIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  className: PropTypes.string,
};

export default MenuIcon;